export function clientFeatureEnabled(feature: string): boolean {
  "use client";
  // This should only be a workaround until nodejs v15
  // Reading the docs makes me think the env variables can be dynamically read, but cant say for sure
  if (feature === "EMAIL_LOGIN_DISABLED") {
    return process.env.NEXT_PUBLIC_FEATURE_EMAIL_LOGIN_DISABLED === "true";
  }
  return false;
}

export function serverFeatureEnabled(feature: string): boolean {
  return process.env[`FEATURE_${feature}`] === "true";
}
